/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientStatusViewModel } from '../../models/client-status-view-model';

export interface Status$Params {
  clientID: number;
}

export function Status(http: HttpClient, rootUrl: string, params: Status$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientStatusViewModel>> {
  const rb = new RequestBuilder(rootUrl, Status.PATH, 'get');
  if (params) {
    rb.path('clientID', params.clientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientStatusViewModel>;
    })
  );
}

Status.PATH = '/api/Clients/Status/{clientID}';
